import { render, staticRenderFns } from "./supplement-details.vue?vue&type=template&id=22cfe716&scoped=true"
import script from "./supplement-details.vue?vue&type=script&lang=js"
export * from "./supplement-details.vue?vue&type=script&lang=js"
import style0 from "./supplement-details.vue?vue&type=style&index=0&id=22cfe716&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cfe716",
  null
  
)

export default component.exports